import { Controller } from "@hotwired/stimulus"

const COLORS = {
  light: "#ffffff",
  dark: "#111827"
}

export default class extends Controller {
  static targets = [ "switch" ]

  connect() {
    this.theme = localStorage.getItem("theme") || "system"
    this.applyTheme(this.theme)
    this.selectButton(this.theme)
  }

  setTheme(event) {
    this.theme = event.target.value
    if (this.theme === "system") {
      localStorage.removeItem("theme")
    } else {
      localStorage.setItem("theme", this.theme)
    }
    this.applyTheme(this.theme)
    this.selectButton(this.theme)
  }

  applyTheme(theme) {
    const metaThemeColor = document.querySelector('meta[name="theme-color"]')
    if (theme === "light") {
      document.documentElement.classList.remove("dark")
      metaThemeColor.setAttribute("content", COLORS.light)
    } else if (theme === "dark") {
      document.documentElement.classList.add("dark")
      metaThemeColor.setAttribute("content", COLORS.dark)
    } else {
      if (window.matchMedia("(prefers-color-scheme: dark)").matches) {
        document.documentElement.classList.add("dark")
        metaThemeColor.setAttribute("content", COLORS.dark)
      } else {
        document.documentElement.classList.remove("dark")
        metaThemeColor.setAttribute("content", COLORS.light)
      }
    }
  }

  selectButton(theme) {
    this.switchTargets.forEach(input => {
      input.checked = input.value === theme
    })
  }
}
